module.exports = __webpack_public_path__ + "static/media/BizTech6.f71a40b7.png";